var cov_2i58hma3qy = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/ready.ts",
      hash = "08679aba470d6f89b08c0570fb1c1cd1a6fe71b3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/ready.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 23
        }
      },
      "1": {
        start: {
          line: 2,
          column: 17
        },
        end: {
          line: 2,
          column: 23
        }
      },
      "2": {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 6,
          column: 3
        }
      },
      "3": {
        start: {
          line: 3,
          column: 41
        },
        end: {
          line: 3,
          column: 51
        }
      },
      "4": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 15
          },
          end: {
            line: 1,
            column: 16
          }
        },
        loc: {
          start: {
            line: 1,
            column: 57
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 23
          }
        }, {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 23
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }, {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }],
        line: 3
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export default function (callback) {
  cov_2i58hma3qy.f[0]++;
  cov_2i58hma3qy.s[0]++;

  if (!callback) {
    cov_2i58hma3qy.b[0][0]++;
    cov_2i58hma3qy.s[1]++;
    return;
  } else {
    cov_2i58hma3qy.b[0][1]++;
  }

  cov_2i58hma3qy.s[2]++;

  if (document.readyState !== 'loading') {
    cov_2i58hma3qy.b[1][0]++;
    cov_2i58hma3qy.s[3]++;
    callback();
  } else {
    cov_2i58hma3qy.b[1][1]++;
    cov_2i58hma3qy.s[4]++;
    document.addEventListener('DOMContentLoaded', callback);
  }
}